export default "__VITE_ASSET__824616a1__"